import { ACTAS_ROSTER } from '../data/roster-config'
import { fitBadgeText } from '../rules/fit'
import type { FitVerdict } from '../rules/fit'

export interface FitBadgeProps {
  verdict: FitVerdict
}

/**
 * The load-bearing badge (`PLAN.md` §3.3). It always shows its verdict's own
 * sentence, with hours when there are hours — *clean fit* / *9.5h rest
 * before your AM* / *can't — overlaps your N, ends 07:00* — built by
 * `fitBadgeText`, never composed here. The component is deliberately
 * incapable of showing a bare "not available": it renders whatever the
 * verdict says, and every verdict says why.
 *
 * Colour is a second signal layered on top of the words, never the only
 * one — the same rule `ShiftCodeChip` states. Clean borrows the vendored
 * teal pair (the palette's own "this works"), warn the amber pair (the
 * house "explained outcome" treatment the sheet status uses), block the red
 * pair.
 */
export function FitBadge({ verdict }: FitBadgeProps) {
  return (
    <span className={`ss-fit-badge ss-fit-badge--${verdict.kind.toLowerCase()}`}>
      {fitBadgeText(verdict, ACTAS_ROSTER)}
    </span>
  )
}
